<template>
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.1741 12.8408H1.79224V11.126H14.1741V12.8408ZM14.1741 8.84082H1.79224V7.12598H14.1741V8.84082ZM14.1741 4.84082H1.79224V3.12598H14.1741V4.84082Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts" setup></script>
